import { render, staticRenderFns } from "./BlogLayout.vue?vue&type=template&id=18efb5df&scoped=true"
import script from "./BlogLayout.vue?vue&type=script&lang=js"
export * from "./BlogLayout.vue?vue&type=script&lang=js"
import style0 from "./BlogLayout.vue?vue&type=style&index=0&id=18efb5df&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18efb5df",
  null
  
)

export default component.exports